import React from "react";
import { Link } from 'react-router-dom'
import VideoModal from '../ModalVideo/VideoModal'

import simg1 from '../../images/slider/right-img.png'
import homebuilding1 from '../../images/homebuilding1.jpeg';
import homebuilding2 from '../../images/homebuilding2.jpeg';
import chrysaliscaccoonlogo from '../../images/chrysaliscaccoonlogo.png';



const Hero = () => {
    return (
      <>
      {/* SCROLL TARGET FOR BACK-TO-TOP */}
      <div id="scrool"></div>

        <div className="home-wrapper">

          {/* =========================== */}
      {/* PAGE TITLE BAR */}
      {/* =========================== */}
      <div className="wpo-page-title">
        <h2>Legacy Community Services</h2>
        <div className="wpo-breadcumb-wrap"></div>
      </div>

      {/* SECTION 1 */}
      <section className="home-section intro-section">
        <h1>Building Partnerships, One Association at a time</h1>
        <p>
          At Legacy Community Services, we believe in fostering strong, lasting
          relationships by working closely with each community we manage, one association at a time.
        </p>
      </section>

      {/* SECTION 2 */}
      <section className="home-section image-section">
      <img src={homebuilding1} alt="Community" />
      </section>

      {/* SECTION 3 */}
      <section className="home-section text-block">
        <h2>Our Vision</h2>
        <p>
          Our Vision is straightforward: to build strong partnerships with our
          clients and the communities we manage by delivering exceptional customer
          service with complete transparency.
        </p>
      </section>

      {/* SECTION 4 */}
      <section className="home-section text-block">
        <h2>Exceptional Customer Service</h2>
        <p>
          At Legacy Community Services, we take pride in delivering exceptional
          customer service to everyone who contacts our offices. Every interaction
          reflects our commitment to professionalism, responsiveness, and a
          personalized approach.
        </p>
      </section>

      {/* SECTION 5 */}
      <section className="home-section text-block">
        <h2>Full Transparency of Association Information</h2>
        <p>
          Through the Legacy Community Services app and Board Portal, our Boards
          have real-time access to association records and financial information,
          ensuring complete transparency and up-to-date insights.
        </p>
        <img src={homebuilding2} alt="Community" />
      </section>

      {/* SECTION 6 */}
      <section className="home-section intro-section">
        <h2>Be Our Partner</h2>
        <p>
          Join the dozens of community associations that entrust Legacy with
          managing operations, providing them value and peace of mind.
        </p>

      </section>

      {/* SECTION 7 */}
      <section className="home-section text-block">
        <h2>The Benefits</h2>
        <p>
          <strong>Efficiency and Expertise:</strong> A professional property management
          company like Legacy Community Services ensures the efficient handling of
          day-to-day operations for Homeowners’ Associations (HOAs). From financial
          management and property maintenance to resident communication, our
          expertise ensures all tasks are managed professionally and effectively.
        </p>
      </section>

      {/* SECTION 8 – THREE COLUMNS */}
      <section className="home-section three-cols">
        <div className="col">
        <img src={chrysaliscaccoonlogo} alt="Icon" />
          <h3>Customer Service</h3>
          <p>
            We take great pride in providing exceptional service with professionalism,
            care, and commitment.
          </p>
        </div>

        <div className="col">
        <img src={chrysaliscaccoonlogo} alt="Icon" />
          <h3>Industry Experts</h3>
          <p>
            Years of HOA industry expertise allow us to guide Boards with informed
            recommendations and deep understanding.
          </p>
        </div>

        <div className="col">
          <img src={chrysaliscaccoonlogo} alt="Icon" />
          <h3>Innovative Technology</h3>
          <p>
            Our Resident & Board Portals provide seamless, efficient access to
            everything your association needs.
          </p>
        </div>
      </section>

      {/* SECTION 9 */}
      <section className="home-section text-block center">
        <h2>Florida Mailing Location</h2>
        <h4>Spring Hill, Florida</h4>
        <p>4142 Mariner Blvd. #255, Spring Hill, FL 34609</p>
        <p>571-313-1004</p>
      </section>

      <section className="home-section text-block center">
        <h2>Virginia Mailing Location</h2>
        <h4>Leesburg, Virginia</h4>
        <p>525K East Market St. #597, Leesburg, VA 20176</p>
        <p>571-313-1004</p>
      </section>

      <section className="home-section text-block center">
        <h2>Virginia Office Locations</h2>
        <h4>Sterling, Virginia</h4>
        <p>45945 Trefoil Lane #112, Sterling, VA 20166</p>
        <p>571-313-1004</p>
      </section>
    </div>
    </>
  );
};



export default Hero;